interface AppConfig {
  baseURL: string;
  company: string;
  useMockAuth: boolean;
  mockEmail: string;
  mockPassword: string;
  mockUser: {
    user: {
      _id: string;
      email: string;
      name: string;
      role: string;
      company: string;
      token: string;
    };
  };
}

// Guard against silently shipping the SixSigma defaults in a production
// build that forgot to set its tenant env vars. We do NOT throw at import (that
// would white-screen the app) — instead we log loudly and export a flag the UI
// can surface as a banner.
const missingBaseURL = !process.env.REACT_APP_BASE_URL;
const missingCompanyId = !process.env.REACT_APP_COMPANY_ID;
export const usingFallbackTenantConfig: boolean = missingBaseURL || missingCompanyId;

if (process.env.NODE_ENV === 'production' && usingFallbackTenantConfig) {
    // eslint-disable-next-line no-console
    console.error(
        '[config] REACT_APP_BASE_URL and/or REACT_APP_COMPANY_ID are NOT set in this ' +
        'production build — falling back to the SixSigma defaults ' +
        '(https://api.cleanspacesapp.com/, company 699c9cb3e661caf8e7bf47cb). ' +
        'If this is not the SixSigma tenant, set BOTH environment variables in the ' +
        'Vercel project and redeploy.'
    );
}

const config: AppConfig = {
    // Reads from Vercel environment variables, falls back to Six Sigma defaults.
    // To deploy for a different company (e.g., OBI), set REACT_APP_BASE_URL and
    // REACT_APP_COMPANY_ID in the Vercel project's Environment Variables.
    baseURL: process.env.REACT_APP_BASE_URL || 'https://api.cleanspacesapp.com/',
    company: process.env.REACT_APP_COMPANY_ID || '699c9cb3e661caf8e7bf47cb',

    // Mock mode - set to false to use real backend authentication
    useMockAuth: false,

    // Mock credentials for local testing
    mockEmail: 'sixsigmaconsultant@icloud.com',
    mockPassword: 'abc123',

    // Mock user data for local testing (only used when useMockAuth is true)
    mockUser: {
        user: {
            _id: 'mock-user-123',
            email: 'sixsigmaconsultant@icloud.com',
            name: 'Test Admin',
            role: 'admin',
            company: '699c9cb3e661caf8e7bf47cb',
            token: 'mock-jwt-token-for-local-testing'
        }
    }
};

export default config;
